document.addEventListener("DOMContentLoaded", function(){

const faqItems = document.querySelectorAll(".faq-item")
const questions = document.querySelectorAll(".faq-question")
const viewAllBtn = document.querySelector(".faq-view-all")

/* accordion */

questions.forEach(btn => {

btn.addEventListener("click", function(){

const item = this.parentElement

faqItems.forEach(i=>{
if(i !== item){
i.classList.remove("active")
}
})

item.classList.toggle("active")

})

})

/* view all */

if(viewAllBtn){

viewAllBtn.addEventListener("click", function(){

document.querySelectorAll(".faq-hidden").forEach(el=>{
el.style.display="block"
})

this.style.display="none"

})

}

})